/**
 * TOON format converter using @toon-format/toon library
 */

import { encode, decode } from '@toon-format/toon';

/**
 * Convert JSON to TOON format
 */
export function jsonToToon(json: string): string {
  try {
    const parsed = JSON.parse(json);
    return encode(parsed, { indent: 2 });
  } catch (error) {
    throw new Error(`Failed to convert JSON to TOON: ${error instanceof Error ? error.message : 'Unknown error'}`);
  }
}

/**
 * Convert TOON to JSON format
 */
export function toonToJson(toon: string): string {
  try {
    const decoded = decode(toon);
    return JSON.stringify(decoded, null, 2);
  } catch (error) {
    throw new Error(`Failed to convert TOON to JSON: ${error instanceof Error ? error.message : 'Unknown error'}`);
  }
}
